import React from 'react';
import { Link } from 'react-router-dom';

import '../stylesheets/bloger-mini.scss';



class BlogerMini extends React.Component {
  render() {
    return (
      <div className='bloger-mini-item-container'>
        <img
          className='bloger-mini-item-image'
          src={this.props.src}
          alt={this.props.alt}
        />
        <div className='bloger-mini-item-description-container'>
          <div
            className='bloger-mini-item-description'
          >
            <div className='bloger-mini-item-author'>
              <h3>{this.props.author}</h3>
            </div>
            <div className='bloger-mini-item-title'>
              <Link to='/blog'>
                <h3>{this.props.title}</h3>
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BlogerMini;